import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const EndSection = (props) => {
  return (
    <Box color="#fff" bgcolor="tertiary.black" py={{ xs: 5, sm: 8 }}>
      <Container>
        <Box maxWidth="781px" mx="auto">
          <Typography
            align="center"
            variant="h4"
            component="h2"
            className="text-light-blue"
          >
            If you are curious, knowledge-hungry, and passionate about creating,
            you are one of us
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

const sizes = {
  xxl: [381, 177],
};

export default EndSection;
